import React from 'react';
import Modal from './Modal';
import { useSettings } from '../../contexts/SettingsContext';
import './SettingsModal.css';

function SettingsModal({ isOpen, onClose }) {
  const { settings, toggleHardMode } = useSettings();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Settings">
      <div className="settings-content">
        <div className="setting-item">
          <div className="setting-info">
            <div className="setting-title">Hard Mode</div>
            <div className="setting-description">
              Any revealed hints must be used in subsequent guesses
            </div>
          </div>
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={settings.hardMode}
              onChange={toggleHardMode}
            />
            <span className="toggle-slider"></span>
          </label>
        </div>
      </div>
    </Modal>
  );
}

export default SettingsModal;
